<template>
  <div>
    <a
      v-if="getProductLinkText"
      class="product_link"
      :href="getProductLink"
      :target="getProductLinkTarget"
      :id="deviceType + 'view-more-link'"
    >
      {{ getProductLinkText }}
      <i class="material-icons">keyboard_arrow_right</i>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    deviceType: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("product", ["getProduct"]),
    getProductLink() {
      var product = this.getProduct;
      if (
        product &&
        product.SelectedSku &&
        product.SelectedSku.ProductLink &&
        product.SelectedSku.ProductLink.Url
      )
        return product.SelectedSku.ProductLink.Url;
      else if (
        product &&
        product.Series &&
        product.Series.ProductLink &&
        product.Series.ProductLink.Url
      )
        return product.Series.ProductLink.Url;
      else return "";
    },
    getProductLinkText() {
      var product = this.getProduct;
      if (product && product.SelectedSku && product.SelectedSku.ProductLinkText)
        return product.SelectedSku.ProductLinkText;
      else if (product && product.Series && product.Series.ProductLinkText)
        return product.Series.ProductLinkText;
      else return "";
    },
    getProductLinkTarget() {
      var product = this.getProduct;
      if (product && product.SelectedSku && product.SelectedSku.ProductLink) {
        return product.SelectedSku.ProductLink.Target;
      } else if (product && product.Series && product.Series.ProductLink)
        return product.Series.ProductLink.Target;
      else return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.productDescription__productLink {
  a {
    i {
      font-size: 18px;
    }
  }
  @include media-breakpoint-up(lg) {
    a:hover {
      text-decoration: underline;
    }
  }
}
::v-deep .product_link {
  color: $primary;
  font-weight: bold;
  font-family: $body;
}
</style>
